const cartRoutes = {
  path: 'carts',
  name: 'cartsOverview',
  components: {
    default: () => import('@/views/PageRoutView')
  },
  redirect: { name: 'carts' },
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '/:channelId/carts',
      name: 'carts-list',
      component: () => import('@/views/Carts/Carts'),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/:channelId/carts/:cartId',
      name: 'carts-detail',
      component: () => import('@/views/Carts/CartDetail'),
      meta: {
        requiresAuth: true
      }
    },
  ]
}

export default cartRoutes
